import { Container } from './styles'

type Props = {
  checked: boolean
  onChange: (value: boolean) => void
  disabled: boolean
}

export const Checkbox = ({ checked, onChange, disabled }: Props) => {
  return (
    <Container>
      <div
        className={`checkbox ${checked ? 'checked' : ''} ${
          disabled ? 'disabled' : ''
        }`}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          disabled={disabled}
        />
      </div>
    </Container>
  )
}
